import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import LoadingDialog from "../commons/LoadingDialog";
import { login } from './network/Login'
import { Message } from 'shineout'
//styles init
const styles = theme => ({
	'@global': {
		body: {
			backgroundColor: theme.palette.common.white,
		},
	},
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
});
//Login component
class Login extends React.Component {
	constructor(props) {
		super(props);
		//state init
		this.state = {
			isLoading: false,
			isDone: false,
			username: '',
			password: '',
			loadingMessage: "Verifying credentials, Please wait",
			status: 0
		}
		//submit handler
		this.handleSubmit = this.handleSubmit.bind()
	}
	//submit handler function
	handleSubmit = event => {
		event.preventDefault();
		//on submit clicked show loading dialog
		this.setState({ isLoading: true });
		this.setState({ isDone: false });
		//call login endpoint for auth
		login({
			username: this.state.username,
			password: this.state.password,
		}, result => {
			//If result is not null login success
			if (result != null) {
				//Login success set state with token & version data, remove loading dialog
				console.log(result);
				this.setState({ status: 200 });
				this.setState({ token: result.token });
				this.setState({ version: result.version });
				this.setState({ isDone: true });
				//show login success message
				Message.success('Login done', 3, { position: 'bottom-right' });
				//return to top level with data
				this.props.onLogin({
					username: this.state.username,
					token: this.state.token,
					version: this.state.version,
				});

			} else {
				//login failed remove loading dialog and show login failed message
				this.setState({ status: 400 });
				this.setState({ isLoading: false });
				Message.error('Login failed', 3, { position: 'bottom-right' });
				this.setState({ isDone: true });
			}
		})
	}
	//page render function
	render() {
		const { classes } = this.props;
		return (
			//layout container
			<Container component="main" maxWidth="xs">
				{/* loading dialog added here */}
				<LoadingDialog
					open={this.state.isLoading}
					status={this.state.isDone}
					message={this.state.loadingMessage} />
				<CssBaseline />
				<div className={classes.paper}>
					{/* lock logo */}
					<Avatar className={classes.avatar}>
						<LockOutlinedIcon />
					</Avatar>
					<Typography component="h1" variant="h5">
						Sign in
                    </Typography>
					<form className={classes.form} noValidate>
						{/* username field */}
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							type="username"
							onChange={event => this.setState({ username: event.target.value })}
							id="username"
							label="username"
							autoComplete="word"
							autoFocus
						/>
						{/* password field */}
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							onChange={event => this.setState({ password: event.target.value })}
							label="Password"
							type="password"
							id="password"
							autoComplete="current-password"
						/>
						{/* submit button */}
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							onClick={this.handleSubmit}
							className={classes.submit}
						>Login</Button>
					</form>
				</div>
			</Container>

		)
	}
}
export default withStyles(styles)(Login);
